import { Card, CardTitle, CardText,CardBody, CardSubtitle } from 'reactstrap';
import { Link } from "react-router-dom";
const CardSecondary = ({
    projectName,
    projectCategory,
    projectSubCategory,
    projectImage,
    projectDate,
    projectLinks,
    status,
    no_of_bids,
    project_id
}) => {
    return (
        <div className="ebw-card__wrap ebw-card__wrap--secondary">
            <Card className="ebw-card ebw-card__secondary">
                <Link className="w-100" to={projectLinks}>
                    <div className="ebw-card__image-wrap">
                        {projectImage && (
                            <div style={{ backgroundImage: `url(${projectImage})` }} className="ebw-card__image-inwrap">
                            </div>
                        )}
                        {!projectImage && (
                            <div className="ebw-card__image-inwrap" style={{backgroundSize:'contain', backgroundImage: `url(/images/logo-trans.svg)` }}>
                            </div>
                        )} 
                    </div>
                    <CardBody className={` ${status ? "d-flex flex-column justify-content-between ebw-card__body-status" : "ebw-card__secondary-body"}`}>
                        <div>
                            <div className="d-flex justify-content-between">
                                <div className="ebw-card__secondary-titles">
                                    <CardTitle className="ebw-card__secondary-title mt-0">{projectName}</CardTitle>
                                    <CardSubtitle className="ebw-card__subtitle mb-0">{projectCategory?.title}</CardSubtitle>
                                </div>
                                <div className="text-right">
                                    {no_of_bids!=0 && (
                                        <div style={{backgroundColor: '#3a4ee8',}} className="ebw-card__label text-center">Bids: {no_of_bids}</div>
                                    )}
                                    <CardText className="ebw-card__date">{projectDate}</CardText>
                                </div>
                            </div>
                            {status === 0 && (
                                <div className="d-flex justify-content-end mt-2">
                                    <Link to={`/projects/project-form/${projectCategory?.id}/${projectSubCategory?.id}?project_id=${project_id}`}>
                                        <button className="btn btn-primary">Edit & Publish</button>
                                    </Link>
                                </div>
                            )}
                        </div>
                    </CardBody>
                </Link>
            </Card>
        </div>
        
    );
}

export default CardSecondary